import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 20.282L15.1363 29L34 11",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGreenCheck;
